var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slide-lite", attrs: { dir: _vm.dir } }, [
    _c(
      "div",
      { staticClass: "slide-lite-wrap", style: _vm.wrapStyle },
      _vm._l(_vm.list, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "slide-item",
            style: _vm.listItemStyle[index] || ""
          },
          [_vm._t("slide", null, { item: item, index: index })],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }